import request from "@/util/http";
import qs from "qs"; //"删除部门"

/*export function fetchMyfile(query) {
    return request({
        url: '/admin/chunkfile/myfile/page',
        method: 'get',
        params: query
    })
}*/

export function fetchMyfile(query) {
  return request({
    url: "/admin/myfiles/page",
    method: "get",
    params: query
  });
} // 上传文件保存

export function saveFile(obj) {
  return request({
    // url: "/admin/myfiles/save",
    url: "/admin/myfiles",
    method: "post",
    data: obj
  });
} // 上传文件保存

export function uploadingUrl(obj) {
  return request({
    url: "/mngfile/chunkfile/beforeUpload",
    method: "get",
    params: obj
  });
}
export function delTableUrl(id) {
  return request({
    url: "/admin/myfiles/" + id,
    method: "delete" // params: obj

  });
}
export function replaceUrl(obj) {
  return request({
    url: "/admin/chunkfile/myfile/replace",
    method: "get",
    params: obj
  });
}
export function uploadFile(name) {
  return request({
    url: "/admin/files/upload/myfile?originalFileName=".concat(name),
    method: "get"
  });
}
export function downFile(id) {
  return request({
    url: "/admin/files/download/myfile/".concat(id),
    method: "get"
  });
}
export function previewFiles(path, id) {
  return request({
    url: "/admin/files/preview/".concat(path, "/").concat(id),
    method: "get"
  });
}
export function getPreviewTxtFiles(path, id) {
  return request({
    url: "/admin/files/preview/txt/".concat(path, "/").concat(id),
    method: "get"
  });
}
export function previewTxtFiles(path, id) {
  return request({
    url: "/admin/files/download/".concat(path, "/").concat(id),
    method: "get"
  });
}
export function previewFilesHttp(url) {
  return request({
    url: "/admin/file/preview?fileUrl=".concat(url),
    method: "post"
  });
}